import script from "./FooterElement.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterElement.vue?vue&type=script&setup=true&lang=js"

import "./FooterElement.vue?vue&type=style&index=0&id=2f952726&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f952726"]])

export default __exports__